import { SectionType } from "@app/constants";
import { ContextMenuItem } from "@app/hooks/useContextMenu";

export const getQuestionContextMenuItems = (
  sectionType: SectionType,
  onClearAnswer: (questionNumber: number) => void,
  questionNumber?: number,
  sectionNumber?: number
): ContextMenuItem[] => {
  return [
    {
      key: "mark-review",
      label: "Mark for Review",
      onClick: () => {},
    },
    {
      key: "clear-answer",
      label: "Clear Answer",
      onClick: () =>
        onClearAnswer(
          [SectionType.READING, SectionType.WRITING].includes(sectionType) &&
            !questionNumber
            ? (sectionNumber as number)
            : (questionNumber as number)
        ),
    },
    {
      key: "add-notes",
      label: "Add Notes",
      onClick: () => {},
    },
  ];
};
